import { render } from "./AddVersionToHistoryModal.vue?vue&type=template&id=5a6e098f&scoped=true"
import script from "./AddVersionToHistoryModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AddVersionToHistoryModal.vue?vue&type=script&charset=utf-8&lang=js"

import "./AddVersionToHistoryModal.vue?vue&type=style&index=0&id=5a6e098f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a6e098f"]])

export default __exports__